import { render, staticRenderFns } from "./SetNetwork.vue?vue&type=template&id=3512b7c2&scoped=true"
import script from "./SetNetwork.vue?vue&type=script&lang=js"
export * from "./SetNetwork.vue?vue&type=script&lang=js"
import style0 from "./SetNetwork.vue?vue&type=style&index=0&id=3512b7c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3512b7c2",
  null
  
)

export default component.exports